import { get, post} from "../common/http.services";

export function getEnquiryByCode(code: any, appContext: any, success: any, error: any) {
    return get(`/enquiry/findbycode?code=${code}`, appContext, success, error);
}

export function getEnquiryByProductId(id: any, appContext: any, success: any, error: any) {
    return get(`/enquiry/findbyproductid?id=${id}`, appContext, success, error);
}

export function getEnquiryProduct(prdId: any, appContext: any, success: any, error: any) {
    return get(`/enquiry/product?prdId=${prdId}`, appContext, success, error);
}

export function searchEnquiry(searchData: any, pageNumber: any, pageSize: any, appContext: any, success: any, error: any) {
    return post(`/enquiry/search/?page=${pageNumber}&size=${pageSize}&sort=creationDate,desc`, searchData, appContext, success, error);
}

export function saveEnquiry(enquiryModel: any, appContext: any, success: any, error: any) {
    return post(`/enquiry`, enquiryModel, appContext, success, error);
}

export function getEnquiryById(id: any, appContext: any, success: any, error: any) {
    return get(`/enquiry/findbyid?id=${id}`, appContext, success, error);
}
